import React from 'react'
import { MenuToggle } from './MenuToggle/MenuToggle';
import  Drawer  from './Drawer/Drawer';

export const Navigation = props => {


    return (
        <div className='Navigation' style={{ display: 'flex', position:'fixed',zIndex: '999'
    }}>
            <Drawer
                isOpen={props.isOpen}
            />
            <MenuToggle
                setOpen={props.setOpen}
                isOpen={props.isOpen}
            />
        </div>
    )
}
